/**
 * 网络请求模块
 */
import { post, uploadFile as upload  } from './ApiHelper'

/**
 * 获取链接token
 */
export const getConectToken = (success, fail) => {
  const des = '获取链接token'
  post(des, '/common/getConnectToken',{
      appId: 'appid',
      secret: 'secret',
  }, success, fail);
}

/**
 * 上传附件
 */
export const uploadFile = (params, success, fail) => {
  const des = "上传附件";
  upload(des, "/common/upload", params, success, fail);
};

export const getSmsCode = (params, success, fail) => {
  const des = '获取手机验证码'
  post(des, '/remote/talentEntrepreneurship/common/getSmsCode', params, success, fail);
}

export const login = (params, success, fail) => {
  const des = '手机验证码登录'
  post(des, '/remote/talentEntrepreneurship/common/login', params, success, fail);
}

export const saveApply = (params, success, fail) => {
  const des = '提交申请表'
  post(des, '/remote/talentEntrepreneurship/applyReport/saveApplyReport', params, success, fail);
}

export const applyList = (params, success, fail) => {
  const des = '申请列表'
  post(des, '/remote/talentEntrepreneurship/applyReport/reportList', params, success, fail);
}

export const applyDetail = (params, success, fail) => {
  const des = '申请详情'
  post(des, '/remote/talentEntrepreneurship/applyReport/detail', params, success, fail);
}

export const queryGwhLb = (params, success, fail) => {
  const des = '查询管委会列表'
  post(des, '/remote/talentEntrepreneurship/applyReport/queryGwhLb', params, success, fail);
}

export const dictType = (params, success, fail) => {
  const des = '获取字典'
  post(des, '/remote/talentEntrepreneurship/common/dictType', params, success, fail);
}

export const tempStorage = (params, success, fail) => {
  const des = '暂存接口'
  post(des, '/remote/talentEntrepreneurship/applyReport/tempStorage', params, success, fail);
}

export const querySb = (params, success, fail) => {
  const des = '查询是否申报'
  post(des, '/remote/talentEntrepreneurship/applyReport/querySb', params, success, fail);
}
